<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>

	<form @submit.prevent="onSubmit">
		<c-card v-show="disabledProject">
			<h3 slot="title" color="green"> {{ $t("pages.projectDetails") }}</h3>
			<cols-row md="4">
				<smart-input :clearable="false" disabled :label="$t('pages.projectForm.contractor')" v-model="form.contractor"
					class="font-weight-bold"></smart-input>
				<smart-input :clearable="false" disabled :label="$t('pages.projectForm.projectName')" v-model="form.name"
					class="font-weight-bold"></smart-input>
			</cols-row>
		</c-card>
		<c-card>
			<h3 slot="title" color="green"> {{ $t("pages.orderForm.companyDetails") }}</h3>
			<v-row>
				<c-col md="4">
					<clients-select
						v-if="!authIsClient"
						:clearable="false" :disable="disabledProject || !isNew"
						v-model="form.client_id"/>
					<branches-select v-if="form.client_id" :clearable="false" required :disable="disabledProject || !isNew"
						lazy="client_id" :filters="{client_id: form.client_id}" v-model="form.branch_id"/>
				</c-col>
				<c-col md="4">
					<branch-card v-if="form.branch_id" :branch-id="form.branch_id"></branch-card>
				</c-col>
			</v-row>
		</c-card>
		<c-card v-show="!disabledProject">
			<h3 slot="title" color="green">{{ $t("pages.orderConsForm.projDetails") }}</h3>
			<cols-row md="6">
				<smart-input :error="inputErrors.contractor" :label="$t('pages.projectForm.contractor')" required
					v-model="form.contractor"></smart-input>
				<smart-input :error="inputErrors.name" :label="$t('pages.projectForm.projectName')" required
					v-model="form.name"></smart-input>
			</cols-row>
			<cols-row md="6">
				<smart-input :error="inputErrors.contact" :label="$t('pages.projectForm.contact')" required
					v-model="form.contact"></smart-input>
				<smart-input :error="inputErrors.contact_tel" :label="$t('pages.orderTable.tel')" required
					v-model="form.contact_tel" :pattern="phonePattern"
					placeholder="05x-xxxxxxx or 0x-xxxxxxx"
				></smart-input>
			</cols-row>

			<cols-row md="6">
				<smart-input :error="inputErrors.contact" :label="$t('pages.orderConsForm.secondContact')"
					v-model="form.contact2"></smart-input>
				<smart-input :error="inputErrors.contact_tel2"
					:label="$t('pages.orderTable.tel') + '  ' + $t('pages.orderConsForm.secondContact') "
					v-model="form.contact2_tel" :pattern="phonePattern"
					placeholder="05x-xxxxxxx or 0x-xxxxxxx"></smart-input>
			</cols-row>

			<cols-row md="6">
				<smart-input :error="inputErrors.contact" :label="$t('pages.orderConsForm.thirdContact')"
					v-model="form.contact3"></smart-input>
				<smart-input :error="inputErrors.contact_tel3"
					:label="$t('pages.orderTable.tel') + '  ' + $t('pages.orderConsForm.thirdContact') "
					v-model="form.contact3_tel" :pattern="phonePattern"
					placeholder="05x-xxxxxxx or 0x-xxxxxxx"></smart-input>
			</cols-row>

			<cols-row md="6">
				<smart-input :error="inputErrors.address" :label="$t('pages.orderForm.measurementAddress')" required
					v-model="form.address"></smart-input>
				<cites-select v-model="form.city" :required="true"/>
			</cols-row>
		</c-card>
		<c-card>
			<h3 slot="title" color="green">{{ $t("pages.orderForm.mesurementDetails") }}</h3>
			<apartment-form v-for="apartment in apartmentsToShow" :current-measurement="currentMeasurement"
				:removedFiles="removedFiles" :key="apartment.id" @remove="removeApartment"
				:apartment="apartment"></apartment-form>
			<div>
				<v-btn light color="blue" @click="addApartment">
					<v-icon left>add</v-icon>
					<v-icon left>mdi-office-building</v-icon>
					{{ $t("pages.orderForm.apartmentAnotherOrder") }}
				</v-btn>
			</div>
		</c-card>

		<cols-row cols="6" :row="{justify:'center'}">
			<btn-loader :progress="inProgress"></btn-loader>
		</cols-row>
	</form>
</template>


<script>
	import ProjectModule from "src/store/modules/Project.module";
	import FormView from "src/mixins/FormView";
	import CCard from "dev/scaffoldings/cCard";
	import BranchesSelect from "dev/view/branches/BranchesSelect";
	import ClientsSelect from "dev/view/clients/ClientsSelect";
	import BtnLoader from "dev/components/BtnLoader";
	import ApartmentForm from "dev/view/orders/ApartmentForm";
	import uniqueId from "lodash/uniqueId";
	import BranchCard from "dev/view/branches/BranchCard";
	import CitesSelect from "dev/view/measurements/CitesSelect";

	export default {
		props: {
			currentMeasurement: Object,
			disabledProject: {default: false},
		},
		name: "construction-form",
		components: {
			CitesSelect,
			BranchCard,
			ApartmentForm,
			BtnLoader,
			ClientsSelect,
			BranchesSelect,
			CCard,
		},
		data() {
			return {
				form: {
					name: null,
					branch_id: null,
					client_id: null,
				},
				phonePattern: "^[0-9]{2,3}-[0-9]{7}",
				apartments: [],
				removedFiles: [],
			};
		},
		mixins: [new FormView(ProjectModule, "project", true)],
		computed: {
			isNew() {
				return !this.project.id;
			},
			branchFilter() {
				return this.form.branch_id;
			},
			auth() {
				return this.$store.state.AuthModule.user;
			},
			authIsClient() {
				return this.$store.getters.isClient;
			},
			apartmentsToShow() {
				if (this.currentMeasurement) {
					return this.apartments.filter((apartment) => {
						return (
							apartment.id == this.currentMeasurement.order_id ||
							(isNaN(apartment.id) && apartment.id.indexOf("notreal") == 0)
						);
					});
				}
				return this.apartments;
			},
		},
		methods: {
			beforeSubmit(formData) {
				let data = Object.assign({}, this.form, {
					apartments: this.apartments,
					removedFiles: this.removedFiles,
				});
				formData.append("project", JSON.stringify(data));
				this.apartments.forEach((apartment) => {
					apartment.measurements.forEach((measurement) => {
						measurement.files.forEach((file) => {
							if (!file.id) {
								formData.append(`files-${measurement.id}[]`, file);
							}
						});
					});
				});
				return formData;
			},
			removeApartment(m) {
				let index = this.apartments.indexOf(m);
				if (index > -1) {
					this.apartments.splice(index, 1);
				}
			},
			addApartment() {
				this.apartments.push({
					id: uniqueId("notreal"),
					measurements: [
						{
							id: uniqueId("notreal"),
							files: [],
						},
					],
				});
			},
		},
		created() {

			if (this.project) {
				this.form = this.project;
			}
      if (this.auth.client_id) {
        this.form.client_id = this.auth.client_id;
      }
		},
		watch: {
			"form.client_id": {
				handler() {
					this.form.branch_id = null;
				},
			},
			"form.orders": {
				handler() {
					if (this.form.orders && this.form.orders.length) {
						this.apartments = this.form.orders.slice(0);
					} else {
						if (!this.apartments.length) {
							this.addApartment();
						}
					}
				},
				immediate: true,
			},
		},
	};
</script>
